import Helmet from 'react-helmet';
import styled from 'styled-components';

import { ThemeProvider, Theme, StyledEngineProvider } from '@mui/material/styles';

import './layout.css';
//import comps
import Header from './Header';
import Footer from './Footer';
import BackToTopButton from './BackToTopButton';

import { mui } from '../theme';
import { Store } from '../store';


declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}


const Layout = ({ children }) => {
    return (
        <Store>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={mui}>
                    <Helmet>
                        <html lang="en" />
                        <link
                            href="https://fonts.googleapis.com/css?family=Roboto:wght@400;500;700;900&display=swap"
                            rel="stylesheet"
                        ></link>
                    </Helmet>
                    <Container>
                        <Header />
                        <BackToTopButton />
                        <Main>{children}</Main>
                        <Footer />
                    </Container>
                </ThemeProvider>
            </StyledEngineProvider>
        </Store>
    );
};

const Container = styled.div`
    min-height: 100vh;
`;

const Main = styled.main`
    position: relative;

    @media (min-width: 640px) {
        min-height: calc(100vh - 134px - 124px);
    }
`;

export default Layout;
